<template>
    <div class="d-flex flex-column">
      <subnav :links="subnav" heading="Лог лист"/>
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>
  </template>
  
  <script>
    export default {
      metaInfo: {title: 'Логи'},
      data: () => ({
        subnav: [
          {
            text: 'Биллинг',
            to: '/billing/logs/billing',
            exact: true,
            permission: 'web_billing_logs',
          },
          {
            text: 'Клиенты',
            to: '/billing/logs/clients',
            exact: true,
            permission: 'web_billing_logs',
          },
          {
            text: 'Администраторы',
            to: '/billing/logs/admins',
            exact: true,
            permission: 'web_billing_logs',
          },
        ],
      }),
    }
  </script>
  


// WEBPACK FOOTER //
// resources/assets/js/pages/billing/logs/index.vue